import { i18nProvider } from "@trumpf/ux.i18n";
import { h, Host, forceUpdate } from "@stencil/core";
import { getNotificationProvider } from "../../apis/notifications";
import { isDefined } from "../../utils/type-check";
import { createNotificationCluster, getClusterName } from "./utils";
const baseClass = "uxc-app-notification-list";
export class AppNotificationList {
    constructor() {
        this.notificationSubscriberId = "";
        this.i18nSubscriberId = "";
        this.renderNotificationItem = (data) => {
            return (h("li", { key: `${data.id}`, class: `${baseClass}__list-item` }, h("ux-notification-item", { source: data.sourceName, headline: data.subject, text: data.message, createdAt: `${data.timestamp}`, dateFormat: this.dateFormat, timeFormat: this.timeFormat, severity: data.severity, type: "Overview" })));
        };
        this.renderError = (err) => {
            const { t } = i18nProvider;
            switch (err.status) {
                case 401:
                    return t("notifications.error.unauthorized", "Unauthorized");
                default:
                    return err.message || t("notifications.error.general");
            }
        };
        this.dateFormat = "YYYY-MM-DD";
        this.timeFormat = "HH:mm:ss";
    }
    connectedCallback() {
        this.notificationSubscriberId = getNotificationProvider().subscribe(() => forceUpdate(this));
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
        getNotificationProvider().unsubscribe(this.notificationSubscriberId);
    }
    render() {
        const { t } = i18nProvider;
        const { notifications, error, pending, loadMore } = getNotificationProvider();
        const hasNotifications = notifications.length > 0;
        const cluster = createNotificationCluster(notifications);
        return (h(Host, { key: 'f05b6f7a8f96ab473adcbf4999f8cdeeba5f0298', class: {
                [`${baseClass}`]: true
            } }, hasNotifications &&
            Object.entries(cluster).map(([clusterName, notifications]) => (h("div", { key: clusterName, class: `${baseClass}__cluster` }, h("header", { class: `${baseClass}__list-header` }, getClusterName(clusterName)), h("ul", { class: `${baseClass}__list` }, notifications.map(this.renderNotificationItem))))), h("div", { key: 'ce4d9d7343e5ffb1efb4636f0467f0464ee115a9', class: `${baseClass}__list-footer` }, pending && h("div", { key: 'ac948a854b887d7b79c36285e6ca6e9f39e326a3', class: "ux-horizontal-loader" }), !pending && hasNotifications && loadMore && (h("div", { key: '8e88886655ed77b55efc7c53e4c7796d3bd7b0c4', class: `${baseClass}__load-more` }, h("ux-button", { key: '8e76d9c54fa7b13f8fbf09fe4e28fc5b19c384e2', onClick: loadMore }, t("notifications.button.loadMore")))), !pending && !hasNotifications && !isDefined(error) && (h("div", { key: 'c9b047ab9f9962dbbe80136b622d254c00fe1c42', class: `${baseClass}__msg--info` }, t("notifications.info.noNotification", "No notifications"))), !pending && !hasNotifications && isDefined(error) && (h("div", { key: 'ff0c230952f30ca9b7be6a0148373fc219614619', class: `${baseClass}__msg--error` }, this.renderError(error))))));
    }
    static get is() { return "uxc-app-notification-list"; }
    static get originalStyleUrls() {
        return {
            "$": ["app-notification-list.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["app-notification-list.css"]
        };
    }
    static get properties() {
        return {
            "dateFormat": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "date format for notifications"
                },
                "attribute": "date-format",
                "reflect": false,
                "defaultValue": "\"YYYY-MM-DD\""
            },
            "timeFormat": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "time format for notifications"
                },
                "attribute": "time-format",
                "reflect": false,
                "defaultValue": "\"HH:mm:ss\""
            }
        };
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=app-notification-list.js.map
